import { useRecoilState, useRecoilValue } from 'recoil'
import apiService from '../services/api'
import { anonymousUser, isAdminState, userState } from './auth'

export { userState } from './auth'

export const useUser = () => {
    const user = useRecoilValue(userState)
    return user ?? anonymousUser
}

const setUserContextInUser = async (role: string, prov: string, uffi: string) => {
    let type = 'U'
    if (uffi.endsWith('000') && role === 'provincia') {
        type = 'P'
    }
    const newctx = await apiService.setGetUserContext(prov, type, uffi)
    // console.log('newctx', newctx)
    return newctx
}

export const useSetContext = () => {
    const [user, setUser] = useRecoilState(userState)
    return (prov: string, uffi: string) => {
        if (user) {
            return setUserContextInUser(user.role, prov, uffi)
                .then((context) => {
                    context && setUser(old => ({ ...(old ?? anonymousUser), context }))
                })
        }
    }
}

export const useIsAdmin = () => {
    const isAdmin = useRecoilValue(isAdminState)
    return isAdmin
}
